import React from "react";
import styled from "styled-components";
import Heroimg from "images/experience/experiencebackground.png";
import { Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import CategorySection from "./Category";
import PopularExperiences from "./PopularExperience";
import DiscoverSection from "./Discover";
import ExperiencesSection from "./Experiences";
import TrendingCitiesSection from "./TrendingCities";
import Testimonials from "./Testimony";
import BookUs from "./Bookus";
import { ReactComponent as SubscribeImg } from "images/experience/Group36.svg";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Hero = styled.div`
  background-image: url(${Heroimg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 643px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 7rem;
  padding-left: 8rem;
  padding-right: 8rem;
`;

const Header = styled.h2`
  color: #ffffff;
  text-align: left;
  margin: 0;
  font-size: 52px;
  font-weight: 700;
  line-height: 72px;
  @media (max-width: 1000px) {
    font-size: 35px;
    line-height: 50px;
  }
`;

const SmallHeader = styled.h2`
  text-align: left;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 100%;
`;

const SmallText = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #ffffff;
`;

const Text1 = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
`;

const Search = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  height: 116px;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 0.5rem;
`;

const SearchTop = styled.div``;

const SearchBottom = styled.div`
  .ant-input-group-wrapper {
    width: 100%;
  }
`;

const Experiences = styled.div`
  padding-top: 7rem;
  padding-left: 8rem;
  padding-right: 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Trending = styled.div`
  padding-top: 7rem;
  padding-left: 8rem;
  padding-right: 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Subscribe = styled.div`
  background-color: #e4f4ff;
  padding-left: 8rem;
  padding-right: 8rem;
`;

const SubscribeContent = styled.div`
  /* margin-left: 5rem;
margin-right: 5rem; */
  margin-top: 5rem;
  margin-bottom: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SubscribeLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const SubscribeRight = styled.div``;

const ExperienceLandingPage: React.FC = () => {
  return (
    <Container>
      <Hero>
        <Header>
          Discover Experiences <br />
          Made for Every
          <br /> Connection
        </Header>
        <SmallText>
          With our transparent and affordable pricing, you can plan, promote
          <br />
          and execute an event without worrying about hidden costs.
        </SmallText>
        <Search>
          <SearchTop>
            <Text1>Looking to book experiences? Let me help you...</Text1>
          </SearchTop>
          <SearchBottom>
            <Input.Search
              placeholder="I need a hotel with parking in central Lagos for one night only"
              enterButton={
                <span>
                  <SearchOutlined /> Search
                </span>
              }
              size="large"
              style={{ width: "100%" }}
            />
          </SearchBottom>
        </Search>
      </Hero>

      <CategorySection />
      <PopularExperiences />
      <DiscoverSection />

      <ExperiencesSection />
      <TrendingCitiesSection />
      <Testimonials />
      <BookUs />
      <Subscribe>
        <SubscribeContent>
          <SubscribeLeft></SubscribeLeft>
          <SubscribeRight>
            <SubscribeImg />
          </SubscribeRight>
        </SubscribeContent>
      </Subscribe>
    </Container>
  );
};

export default ExperienceLandingPage;
